import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import CheckmarkOutline12Svg from './CheckmarkOutline12.svg.js';
import ChevronBackOutline12Svg from './ChevronBackOutline12.svg.js';
import ChevronDownOutline12Svg from './ChevronDownOutline12.svg.js';
import ChevronForwardOutline12Svg from './ChevronForwardOutline12.svg.js';
import ChevronUpOutline12Svg from './ChevronUpOutline12.svg.js';
import ClearOutline12Svg from './ClearOutline12.svg.js';
import EditOutline12Svg from './EditOutline12.svg.js';
import MinusOutline12Svg from './MinusOutline12.svg.js';
import OpeningHoursOutline12Svg from './OpeningHoursOutline12.svg.js';
import PlusOutline12Svg from './PlusOutline12.svg.js';
import ReplaceOutline12Svg from './ReplaceOutline12.svg.js';
import RestaurantOutline12Svg from './RestaurantOutline12.svg.js';
import RiskIndicatorEmptyOutline12Svg from './RiskIndicatorEmptyOutline12.svg.js';
import RiskIndicatorFilled12Svg from './RiskIndicatorFilled12.svg.js';
import UserFilled12Svg from './UserFilled12.svg.js';
import UserOutline12Svg from './UserOutline12.svg.js';
import { Icon } from '../../components/Icon/Icon.js';

var CheckmarkOutline12 = function CheckmarkOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckmarkOutline12Svg, null)
  }));
};
var ChevronBackOutline12 = function ChevronBackOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronBackOutline12Svg, null)
  }));
};
var ChevronDownOutline12 = function ChevronDownOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronDownOutline12Svg, null)
  }));
};
var ChevronForwardOutline12 = function ChevronForwardOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronForwardOutline12Svg, null)
  }));
};
var ChevronUpOutline12 = function ChevronUpOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronUpOutline12Svg, null)
  }));
};
var ClearOutline12 = function ClearOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ClearOutline12Svg, null)
  }));
};
var EditOutline12 = function EditOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EditOutline12Svg, null)
  }));
};
var MinusOutline12 = function MinusOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MinusOutline12Svg, null)
  }));
};
var OpeningHoursOutline12 = function OpeningHoursOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursOutline12Svg, null)
  }));
};
var PlusOutline12 = function PlusOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PlusOutline12Svg, null)
  }));
};
var ReplaceOutline12 = function ReplaceOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReplaceOutline12Svg, null)
  }));
};
var RestaurantOutline12 = function RestaurantOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RestaurantOutline12Svg, null)
  }));
};
var RiskIndicatorEmptyOutline12 = function RiskIndicatorEmptyOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorEmptyOutline12Svg, null)
  }));
};
var RiskIndicatorFilled12 = function RiskIndicatorFilled12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorFilled12Svg, null)
  }));
};
var UserFilled12 = function UserFilled12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserFilled12Svg, null)
  }));
};
var UserOutline12 = function UserOutline12(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserOutline12Svg, null)
  }));
};

export { CheckmarkOutline12, ChevronBackOutline12, ChevronDownOutline12, ChevronForwardOutline12, ChevronUpOutline12, ClearOutline12, EditOutline12, MinusOutline12, OpeningHoursOutline12, PlusOutline12, ReplaceOutline12, RestaurantOutline12, RiskIndicatorEmptyOutline12, RiskIndicatorFilled12, UserFilled12, UserOutline12 };
//# sourceMappingURL=index.js.map
